import { render, staticRenderFns } from "./parts.vue?vue&type=template&id=77c7f6cf&scoped=true&"
import script from "./parts.vue?vue&type=script&lang=js&"
export * from "./parts.vue?vue&type=script&lang=js&"
import style0 from "./parts.vue?vue&type=style&index=0&id=77c7f6cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c7f6cf",
  null
  
)

export default component.exports